// Pure helpers for the TMDB rating badge shown on poster cards.
//
// Extracted from MediaCard.vue so the same suppression + formatting rules drive
// every surface that shows a rating (MediaCard, the Similar shelf on
// BrowseMediaView, the Filmography grid on PersonView). Vue-free → node --test'able.

// Hide rating noise from under-voted items. A handful of votes can produce a
// wildly swingy average, so titles below this threshold show no badge at all.
export const MIN_VOTE_COUNT = 50;

// Should a rating badge render for these vote stats?
//   - no badge when the average is missing / non-numeric / <= 0
//   - no badge when vote_count is a number below MIN_VOTE_COUNT
//   - vote_count may legitimately be undefined (some trending/older entries
//     omit it); in that case we still show rather than hide everything.
export function shouldShowRating(voteAverage, voteCount) {
  if (typeof voteAverage !== "number" || voteAverage <= 0) return false;
  if (typeof voteCount === "number" && voteCount < MIN_VOTE_COUNT) return false;
  return true;
}

// One-decimal display string ("7.4"), or "" when no badge should show.
export function formatRating(voteAverage, voteCount) {
  if (!shouldShowRating(voteAverage, voteCount)) return "";
  return voteAverage.toFixed(1);
}
